export const PLANO_EMPRESA_ENUM = Object.freeze({
  STARTUP: 'STARTUP',
  PRO: 'PRO',
  BUSINESS: 'BUSINESS',
});
